import * as z from "zod";

export const updateReturnWithWaivedShippingFee = {
  name: "updateReturnWithWaivedShippingFee" as const,
  input: z.object({ id: z.string(), waivedShippingFee: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
